/* eslint-disable */
import React from 'react';
import { Ico } from './ShellIcons';
import fb from './filterBar.module.css';
import pop from './popovers.module.css';

// ============================================================
// The inline (non-popover) filter shapes of the bar:
//   SegField    — one choice out of a few, as a segmented control; `alt`
//                 gives it a pill form (LABEL · value) the bar swaps in when
//                 room gets tight (collapse step cAlt).
//   ChipsField  — one choice as outlined chips (years, periods).
//   ToggleField — a boolean with a small switch and a count.
// Options: [{ value, label?, count?, red?, disabled?, title? }]. value: the
// chosen option's value (seg/chips) or a boolean (toggle).
// ============================================================

const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));
const lab = (o) => (o.label != null ? String(o.label) : String(o.value));

export function Seg({ field, inner }) {
  const cur = field.value;
  return (
    <div className={`${fb.seg} ${field.tag ? fb.tagged : ''}`} role="group" aria-label={field.ariaLabel || field.alt || field.label || field.key}>
      {field.tag && <span className={fb.segTag}>{field.tag}</span>}
      {field.options.map((o) => (
        <button key={String(o.value)} type="button" className={cur === o.value ? fb.on : ''} aria-pressed={cur === o.value} disabled={o.disabled} title={o.title} onClick={(e) => { e.stopPropagation(); field.onChange(o.value); }}>
          {lab(o)}{o.count != null && <span className={`${fb.k} ${o.red ? fb.red : ''}`} data-k>{fmt(o.count)}</span>}
        </button>
      ))}
    </div>
  );
}

// `field.extra` — a render function for one more chip the portal owns (the
// Sales Custom Range picker): it rides inside the group, so it collapses with
// the chips into the alt pill and into More rather than standing alone.
export function Chips({ field }) {
  const cur = field.value;
  return (
    <div className={fb.chips} role="group" data-kind="chips" aria-label={field.ariaLabel || field.alt || field.label || field.key}>
      {field.options.map((o) => (
        <button key={String(o.value)} type="button" className={`${fb.rchip} ${cur === o.value ? fb.on : ''}`} aria-pressed={cur === o.value} disabled={o.disabled} title={o.title} onClick={(e) => { e.stopPropagation(); field.onChange(o.value); }}>
          {lab(o)}{o.count != null && <span className={fb.k} data-k>{fmt(o.count)}</span>}
        </button>
      ))}
      {field.extra ? field.extra() : null}
    </div>
  );
}

// The alt pill — the compact form of a seg/chips field, with its own popover.
function AltPill({ field, open, onToggle }) {
  const cur = field.options.find((o) => o.value === field.value);
  return (
    <div className={`${fb.ffw} ${fb.altF}`} data-ffw="alt" data-prio={field.priority || 1}>
      <button type="button" className={`${fb.ff} ${fb.on} ${open ? fb.open : ''}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-expanded={open}>
        <span className={fb.fl}>{field.alt}</span><span className={fb.fv}>{cur ? lab(cur) : (field.noneLabel || 'All')}</span><Ico name="chev" className={fb.chev} />
      </button>
      {open && (
        <div className={pop.fpop} data-shell-pop onClick={(e) => e.stopPropagation()}>
          <div className={pop.fpHead}><span className={pop.fpT}>{field.alt}</span></div>
          <div className={`${pop.segWrap} ${pop.col}`}>{field.type === 'chips' ? <Chips field={field} /> : <Seg field={field} inner />}</div>
        </div>
      )}
    </div>
  );
}

export function SegField({ field, open, onToggle }) {
  return (
    <>
      <div className={`${fb.ffw} ${field.alt ? fb.alt : ''}`} data-ffw="seg" data-has-alt={field.alt ? '1' : '0'} data-prio={field.priority || 1}><Seg field={field} /></div>
      {field.alt && <AltPill field={field} open={open} onToggle={onToggle} />}
    </>
  );
}

export function ChipsField({ field, open, onToggle }) {
  return (
    <>
      <div className={`${fb.ffw} ${field.alt ? fb.alt : ''}`} data-ffw="chips" data-has-alt={field.alt ? '1' : '0'} data-prio={field.priority || 1}><Chips field={field} /></div>
      {field.alt && <AltPill field={field} open={open} onToggle={onToggle} />}
    </>
  );
}

export function Toggle({ field }) {
  const on = !!field.value;
  return (
    <button type="button" className={`${fb.tog} ${on ? fb.on : ''}`} role="switch" aria-checked={on} onClick={(e) => { e.stopPropagation(); field.onChange(!on); }} title={field.title}>
      <span className={`${fb.tgl} ${on ? fb.on : ''}`} /><span>{field.label}</span>{field.count != null && <span className={fb.k} data-k>{fmt(field.count)}</span>}
    </button>
  );
}

export function ToggleField({ field }) {
  return <div className={`${fb.ffw} ${fb.ftog}`} data-ffw="tog" data-prio={field.priority || 1}><Toggle field={field} /></div>;
}
